import script from "./SpeakCoursewareCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpeakCoursewareCard.vue?vue&type=script&lang=ts&setup=true"

import "./SpeakCoursewareCard.vue?vue&type=style&index=0&id=4e337ba0&scoped=true&lang=css"
import "./SpeakCoursewareCard.vue?vue&type=style&index=1&id=4e337ba0&lang=less&scoped=true"
script.__scopeId = "data-v-4e337ba0"

export default script